(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asjgalg"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hoidasi-nook-below')) {
  customElements.define('hoidasi-nook-below', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelectorAll('[data-hn-explore]').forEach(explore => {
        const select = id => {
          explore.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
          explore.querySelectorAll('button[data-point]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.point === id)));
        };
        explore.addEventListener('click', event => {
          const button = event.target.closest('button[data-point]');
          if (button) select(button.dataset.point);
        }, { signal });
        const first = explore.querySelector('[data-panel]');
        if (first) select(first.dataset.panel);
        explore.classList.add('is-ready');
      });
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-hn-buy]');
        if (!link) return;
        const form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        event.preventDefault();
        form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }, { signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoidasi-review-mockup"] && !Shopify.designMode) return;
  try {
    
  if (!window.hoidasiReviewMockupBound) {
    window.hoidasiReviewMockupBound = true;
    document.addEventListener('click', function(event) {
      const button = event.target.closest('[data-hd-review-mockup] button[data-step]');
      if (!button) return;
      const root = button.closest('[data-hd-review-mockup]');
      const track = root.querySelector('.hd-review-mockup__track');
      const card = track.querySelector('.hd-review-mockup__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({left:(card.getBoundingClientRect().width+gap)*Number(button.dataset.step),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projector"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lumi-below-pdp')) {
  customElements.define('lumi-below-pdp', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelectorAll('.lb-comparison input').forEach(input => {
        input.addEventListener('input', () => input.parentElement.style.setProperty('--lb-position', input.value + '%'), { signal });
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
          if (target.dataset.userPaused === 'true') return;
          if (isIntersecting && !document.hidden) target.play().catch(() => {});
          else target.pause();
        });
      }, { threshold: 0.25 });
      this.querySelectorAll('[data-auto="true"] video').forEach(video => {
        video.addEventListener('pointerdown', () => { video.dataset.userPaused = 'true'; this.observer.unobserve(video); }, { signal });
        video.addEventListener('keydown', () => { video.dataset.userPaused = 'true'; this.observer.unobserve(video); }, { signal });
        this.observer.observe(video);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, { signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projectorpremium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hoidasi-motion')) {
  customElements.define('hoidasi-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.motionCleanup) this.motionCleanup();
      const videos = Array.from(this.querySelectorAll('video'));
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visible = new Set();
      const shouldAutoplay = () => this.dataset.autoplay === 'true' && !preference.matches && !document.hidden;
      const tryPlay = (video) => {
        if (!shouldAutoplay()) return;
        video.muted = true;
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => {});
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) { visible.add(target); tryPlay(target); }
          else { visible.delete(target); target.pause(); }
        });
      }, { threshold: 0.25 }) : null;
      videos.forEach(video => { if (observer) observer.observe(video); });
      const onPreference = () => {
        videos.forEach(video => video.pause());
        if (shouldAutoplay()) visible.forEach(tryPlay);
      };
      const onVisibility = () => {
        if (document.hidden) videos.forEach(video => video.pause());
        else if (shouldAutoplay()) visible.forEach(tryPlay);
      };
      preference.addEventListener('change', onPreference);
      document.addEventListener('visibilitychange', onVisibility);
      this.motionCleanup = () => {
        if (observer) observer.disconnect();
        preference.removeEventListener('change', onPreference);
        document.removeEventListener('visibilitychange', onVisibility);
        videos.forEach(video => video.pause());
      };
    }
    disconnectedCallback() { if (this.motionCleanup) { this.motionCleanup(); this.motionCleanup = null; } }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-nook-explore"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('up-nook-explore')) {
    customElements.define('up-nook-explore', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-point]');
          if (button && this.contains(button)) this.selectPoint(button.dataset.point);
        }, options);
        this.addEventListener('keydown', (event) => {
          const button = event.target.closest('button[data-point]');
          if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          const buttons = [...this.querySelectorAll(button.classList.contains('up-nook-explore__point') ? '.up-nook-explore__point' : '.up-nook-explore__nav button')];
          let index = buttons.indexOf(button);
          index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          event.preventDefault();
          buttons[index].focus();
          this.selectPoint(buttons[index].dataset.point);
        }, options);
        this.addEventListener('shopify:block:select', (event) => this.selectPoint(event.detail.blockId), options);
        this.selectPoint(this.querySelector('[data-panel]')?.dataset.panel);
        this.classList.add('is-ready');
      }
      disconnectedCallback() { this.controller?.abort(); }
      selectPoint(id) {
        if (![...this.querySelectorAll('[data-panel]')].some(panel => panel.dataset.panel === id)) return;
        this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
        this.querySelectorAll('button[data-point]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.point === id)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
